// extracted by mini-css-extract-plugin
export var cardIcon = "_8w-4";
export var checkboxCard = "_8w-0";
export var checkboxCardSelected = "_8w-3";
export var disabled = "_8w-1";
export var outerBorder = "_8w-2";
export var spacerMedium = "_8w-7";
export var spacerSmall = "_8w-6";
export var spacerXsmall = "_8w-5";